<section class="w-full bg-white px-6 py-16">
  <div class="w-full mx-auto">
    <!-- Título de la sección -->
    <div class="flex flex-col gap-2 items-start justify-center text-left mb-10">
      <h2
        class="text-neutral-gray-900 text-2xl font-poppins font-semibold leading-tight m-0"
      >
        Nuestros Productos
      </h2>
      <p
        class="text-neutral-gray-600 font-poppins text-base font-normal leading-4 m-0"
      >
        Materiales para tu obra
      </p>
    </div>

    <!-- Categorías de productos -->
    <div *ngIf="loading" class="flex items-center justify-center py-12">
      <p class="text-neutral-gray-600 font-poppins text-base">Cargando productos...</p>
    </div>

    <div
      *ngIf="!loading && categories.length === 0"
      class="flex items-center justify-center py-12"
    >
      <p class="text-neutral-gray-600 font-poppins text-base">
        No hay productos disponibles
      </p>
    </div>

    <div *ngIf="!loading && categories.length > 0" class="flex flex-col gap-10">
      <div
        *ngFor="let category of categories; let catIndex = index"
        class="flex flex-col gap-6"
      >
        <!-- Título de categoría -->
        <h3
          class="text-neutral-gray-900 text-xl font-poppins font-semibold leading-tight m-0"
        >
          {{ category.name }}
        </h3>

        <!-- Carrusel de productos -->
        <div
          #carousel
          class="flex gap-2 overflow-x-auto scrollbar-hide snap-x snap-mandatory -mr-6 pr-6"
          style="
            scroll-behavior: auto;
            scrollbar-width: none;
            -ms-overflow-style: none;
          "
          (scroll)="updateCurrentIndexFromScroll(catIndex)"
        >
          <div
            class="bg-neutral-gray-100 w-[140px] border-2 border-neutral-gray-300 rounded-lg p-3 flex flex-col gap-4 items-center flex-shrink-0 transition-transform duration-300 cursor-pointer hover:border-cantera-red-stepper snap-start min-h-[280px]"
            *ngFor="let product of category.products"
          >
            <!-- Imagen del producto -->
            <div
              class="relative w-[116px] h-[120px] flex items-center justify-center flex-shrink-0"
            >
              <img
                [src]="product.imageUrl"
                [alt]="product.name"
                class="w-full h-full object-contain"
                (error)="$event.target.src = 'assets/icons/cemento.svg'"
              />
            </div>

            <!-- Info del producto -->
            <div
              class="flex flex-col gap-1 items-start w-[116px] flex-1 min-h-[80px] justify-between"
            >
              <div class="flex flex-col gap-1 w-full">
                <p
                  class="text-neutral-gray-500 text-xs font-poppins font-bold leading-none tracking-wider uppercase m-0 flex-shrink-0"
                >
                  {{ product.category }}
                </p>
                <p
                  class="text-neutral-gray-900 text-base font-poppins font-semibold leading-tight m-0 break-words hyphens-auto"
                >
                  {{ toTitleCase(product.name) }}
                </p>
              </div>
            </div>

            <!-- Botón Ver más -->
            <button
              class="border-2 border-neutral-gray-900 rounded-lg h-12 flex items-center justify-center gap-2 px-4 py-[14px] w-[116px] hover:bg-neutral-gray-900 hover:text-white transition-colors flex-shrink-0"
              (click)="onProductClick(product)"
              >
              <span
                class="w-full text-[14px] leading-[16px] font-poppins font-semibold"
                >Ver más</span
              >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="12"
                viewBox="0 0 14 12"
                fill="none"
              >
                <path
                  d="M6.81324e-08 5.71427C7.44038e-08 5.18836 0.42627 4.76127 0.952149 4.76114L10.0811 4.76114L6.94531 1.6254C6.57359 1.25356 6.57371 0.650635 6.94531 0.27872C7.3172 -0.0931717 7.92006 -0.0930991 8.29199 0.27872L13.0547 5.04044C13.0989 5.08466 13.138 5.13376 13.1729 5.18595C13.182 5.19962 13.1899 5.21392 13.1982 5.22794C13.2056 5.24035 13.2139 5.25228 13.2207 5.26505C13.227 5.2769 13.2325 5.28913 13.2383 5.30118C13.2465 5.31822 13.2545 5.33535 13.2617 5.35294C13.2691 5.37092 13.275 5.38931 13.2813 5.40763C13.2842 5.4164 13.2873 5.42511 13.29 5.43399C13.2938 5.44626 13.2965 5.45873 13.2998 5.4711C13.311 5.51375 13.3199 5.55719 13.3252 5.60196C13.334 5.67667 13.3341 5.75187 13.3252 5.82657C13.3197 5.87333 13.3109 5.91886 13.2988 5.96329C13.2963 5.97275 13.2939 5.98222 13.291 5.99161C13.2857 6.00912 13.2797 6.0263 13.2734 6.04337C13.2695 6.05409 13.2661 6.065 13.2617 6.0756C13.2545 6.09317 13.2465 6.11033 13.2383 6.12735C13.2325 6.13939 13.227 6.15165 13.2207 6.16349C13.2139 6.17625 13.2056 6.18819 13.1982 6.2006C13.1899 6.2146 13.182 6.22893 13.1729 6.24259C13.1381 6.29452 13.0987 6.34308 13.0547 6.38712L8.29199 11.1488C7.92006 11.5207 7.31721 11.5207 6.94531 11.1488C6.57371 10.7769 6.57358 10.174 6.94531 9.80216L10.0811 6.66642L0.952148 6.66642C0.426414 6.66629 0.000234137 6.23998 6.81324e-08 5.71427Z"
                  fill="#20202A"
                />
              </svg>
            </button>
          </div>
        </div>

        <!-- Controles del carrusel -->
        <div class="flex gap-4 items-center justify-center">
          <!-- Botón anterior -->
          <button
            (click)="scrollCarouselHorizontal(catIndex, 'prev')"
            class="rounded-full w-10 h-10 flex items-center justify-center transition-colors"
            [class.bg-neutral-gray-200]="bulletsData[catIndex]?.isPrevEnabled"
            [class.hover:bg-neutral-gray-300]="bulletsData[catIndex]?.isPrevEnabled"
            [class.bg-neutral-gray-100]="!bulletsData[catIndex]?.isPrevEnabled"
            [class.cursor-not-allowed]="!bulletsData[catIndex]?.isPrevEnabled"
            [disabled]="!bulletsData[catIndex]?.isPrevEnabled"
            [attr.aria-label]="'Ir a página anterior'"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              class="rotate-90"
            >
              <path
                d="M6 9l6 6 6-6"
                [attr.stroke]="
                  !bulletsData[catIndex]?.isPrevEnabled ? '#AEAEB8' : '#20202A'
                "
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>

          <!-- Bullets -->
          <div class="flex gap-2 items-center">
            <button
              *ngFor="let bullet of bulletsData[catIndex]?.bullets || []; let i = index"
              class="rounded-full w-2 h-2 transition-colors cursor-pointer hover:scale-125 transition-transform"
              [class.bg-neutral-gray-900]="i === bulletsData[catIndex]?.currentBullet"
              [class.bg-neutral-gray-300]="i !== bulletsData[catIndex]?.currentBullet"
              (click)="scrollToBullet(catIndex, i)"
              [attr.aria-label]="'Ir a página ' + (i + 1)"
            ></button>
          </div>

          <!-- Botón siguiente -->
          <button
            (click)="scrollCarouselHorizontal(catIndex, 'next')"
            class="rounded-full w-10 h-10 flex items-center justify-center transition-colors"
            [class.bg-neutral-gray-200]="bulletsData[catIndex]?.isNextEnabled"
            [class.hover:bg-neutral-gray-300]="bulletsData[catIndex]?.isNextEnabled"
            [class.bg-neutral-gray-100]="!bulletsData[catIndex]?.isNextEnabled"
            [class.cursor-not-allowed]="!bulletsData[catIndex]?.isNextEnabled"
            [disabled]="!bulletsData[catIndex]?.isNextEnabled"
            [attr.aria-label]="'Ir a página siguiente'"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              class="-rotate-90"
            >
              <path
                d="M6 9l6 6 6-6"
                [attr.stroke]="
                  !bulletsData[catIndex]?.isNextEnabled ? '#AEAEB8' : '#20202A'
                "
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>

        <!-- Separador entre categorías -->
        <div
          *ngIf="catIndex < categories.length - 1"
          class="h-0 w-full border-t-2 border-neutral-gray-200 my-4"
        ></div>
      </div>
    </div>
  </div>
</section>

<!-- Modal de Producto - Bottom Sheet -->
<div
  *ngIf="showProductModal && selectedProduct"
  class="fixed inset-0 z-[10000] bg-black/50"
  (click)="closeProductModal()"
>
  <div
    class="absolute bottom-0 left-0 right-0 bg-white rounded-t-3xl max-h-[85vh] overflow-y-auto"
    (click)="$event.stopPropagation()"
  >
    <!-- Header con botón cerrar -->
    <div class="sticky top-0 bg-white rounded-t-3xl z-1 px-6 pt-6 z-[100]">
      <div class="flex items-center justify-end">
        <button
          type="button"
          class="w-10 h-10 flex items-center justify-center text-neutral-gray-900 hover:bg-neutral-gray-100 rounded-lg transition"
          (click)="closeProductModal()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M15.25 13.9167C15.4167 14.0833 15.5 14.3333 15.5 14.5833C15.5 14.8333 15.4167 15.0833 15.25 15.25C15.1667 15.3333 15.0833 15.4167 15 15.4167C14.9167 15.5 14.75 15.5 14.6667 15.5C14.5833 15.5 14.4167 15.5 14.3333 15.4167C14.25 15.3333 14.1667 15.3333 14.0833 15.25L7.75 9.08333L1.58333 15.25C1.5 15.3333 1.41667 15.4167 1.33333 15.4167C1.08333 15.5 0.833333 15.5 0.583333 15.4167C0.5 15.4167 0.333333 15.3333 0.25 15.25C0.0833333 15.0833 4.34617e-08 14.8333 4.34617e-08 14.5833C4.34617e-08 14.3333 0.0833333 14.0833 0.25 13.9167L6.41667 7.75L0.25 1.58333C-0.0833333 1.25 -0.0833333 0.666667 0.25 0.25C0.583333 -0.0833333 1.16667 -0.0833333 1.58333 0.25L7.75 6.41667L13.9167 0.25C14.25 -0.0833333 14.8333 -0.0833333 15.25 0.25C15.5833 0.583333 15.5833 1.16667 15.25 1.58333L9.08333 7.75L15.25 13.9167Z"
              fill="#20202A"
            />
          </svg>
        </button>
      </div>
    </div>

    <!-- Contenido -->
    <div class="px-6 pb-6">
      <!-- Imagen del producto -->
      <div class="flex justify-center mb-6">
        <div class="w-[232px] h-[232px] flex items-center justify-center">
          <img
            [src]="selectedProduct.imageUrl"
            [alt]="selectedProduct.name"
            class="w-[200px] h-[200px] object-contain"
            (error)="$event.target.src = 'assets/icons/cemento.svg'"
          />
        </div>
      </div>

      <!-- Información del producto -->
      <div class="mb-6">
        <p
          class="text-neutral-gray-600 text-[14px] font-poppins font-bold leading-none tracking-wider uppercase mb-2"
        >
          {{ selectedProduct.category }}
        </p>
        <h3
          class="text-[20px] font-poppins font-bold text-neutral-gray-900 mb-2 leading-tight"
        >
          {{ selectedProduct.name }}
        </h3>

        <!-- Línea divisoria -->
        <div class="flex justify-center my-3 w-full">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-full h-[2px]"
            viewBox="0 0 100 2"
            fill="none"
            preserveAspectRatio="none"
          >
            <path
              d="M0 1H100"
              stroke="#E8E9ED"
              stroke-width="2"
              vector-effect="non-scaling-stroke"
            />
          </svg>
        </div>

        <p class="text-sm text-neutral-gray-600 font-poppins leading-relaxed">
          {{ getProductSubtitle(selectedProduct.name) }}
        </p>
      </div>

      <!-- Accordion Usos principales -->
      <div class="mb-6 bg-neutral-gray-100 rounded-xl p-4">
        <button
          (click)="toggleApplication()"
          class="w-full flex items-center justify-between"
        >
          <span class="text-base font-poppins font-semibold text-neutral-gray-900"
            >Usos principales</span
          >
          <!--  <svg 
          width="20" 
          height="20" 
          viewBox="0 0 24 24" 
          fill="none"
          class="transition-transform duration-300 flex-shrink-0"
          [class.rotate-180]="!!isApplicationOpen"
        >
          <path d="M18 15l-6-6-6 6" stroke="#E62721" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg> -->

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="8"
            viewBox="0 0 14 8"
            fill="none"
            [class.rotate-180]="!!isApplicationOpen"
            class="transition-transform duration-300 flex-shrink-0"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M13.7071 7.70711C13.3166 8.09763 12.6834 8.09763 12.2929 7.70711L7 2.41421L1.70711 7.70711C1.31658 8.09763 0.683417 8.09763 0.292893 7.70711C-0.0976315 7.31658 -0.0976316 6.68342 0.292893 6.29289L6.29289 0.292894C6.68342 -0.0976308 7.31658 -0.0976309 7.70711 0.292894L13.7071 6.29289C14.0976 6.68342 14.0976 7.31658 13.7071 7.70711Z"
              fill="#E62721"
            />
          </svg>
        </button>

        <!-- Contenido del accordion -->
        <div *ngIf="isApplicationOpen" class="mt-4 animate-fade-in">
          <p
            class="text-sm text-neutral-gray-900 font-poppins leading-relaxed whitespace-pre-line"
          >
            {{ selectedProduct.mainUses }}
          </p>
        </div>
      </div>

      <!-- Accordion Ventaja -->
      <div class="mb-6 bg-neutral-gray-100 rounded-xl p-4">
        <button
          (click)="toggleAdvantage()"
          class="w-full flex items-center justify-between"
        >
          <span class="text-base font-poppins font-semibold text-neutral-gray-900"
            >Ventaja</span
          >
          <!-- <svg 
          width="20" 
          height="20" 
          viewBox="0 0 24 24" 
          fill="none"
          class="transition-transform duration-300 flex-shrink-0"
          [class.rotate-180]="!isAdvantageOpen"
        >
          <path d="M18 15l-6-6-6 6" stroke="#E62721" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg> -->

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="8"
            viewBox="0 0 14 8"
            fill="none"
            [class.rotate-180]="!!isAdvantageOpen"
            class="transition-transform duration-300 flex-shrink-0"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M13.7071 7.70711C13.3166 8.09763 12.6834 8.09763 12.2929 7.70711L7 2.41421L1.70711 7.70711C1.31658 8.09763 0.683417 8.09763 0.292893 7.70711C-0.0976315 7.31658 -0.0976316 6.68342 0.292893 6.29289L6.29289 0.292894C6.68342 -0.0976308 7.31658 -0.0976309 7.70711 0.292894L13.7071 6.29289C14.0976 6.68342 14.0976 7.31658 13.7071 7.70711Z"
              fill="#E62721"
            />
          </svg>
        </button>

        <!-- Contenido del accordion -->
        <div *ngIf="isAdvantageOpen" class="mt-4 animate-fade-in">
          <p
            class="text-sm text-neutral-gray-900 font-poppins leading-relaxed whitespace-pre-line"
          >
            {{ selectedProduct.advantages }}
          </p>
        </div>
      </div>
    </div>

    <!-- Botón Cotizar -->
    <div class="sticky bottom-0 bg-white border-t border-neutral-gray-200 p-4 pb-6">
      <button
        type="button"
        class="w-full h-14 rounded-xl font-bold text-white transition-colors hover:opacity-95 bg-cantera-red-primary"
        (click)="openQuoteModal()"
      >
        Cotizar
      </button>
    </div>
  </div>
</div>

<!-- Modal de Registro/Login -->
<div
  *ngIf="showQuoteModal"
  class="fixed inset-0 z-[10001] flex items-center justify-center p-4 bg-black/50"
  (click)="closeQuoteModal()"
>
  <div
    class="bg-white rounded-3xl w-full max-w-md p-8 relative"
    (click)="$event.stopPropagation()"
  >
    <!-- Botón cerrar -->
    <button
      type="button"
      class="absolute top-4 right-4 w-10 h-10 flex items-center justify-center text-neutral-gray-900 hover:bg-neutral-gray-100 rounded-lg transition"
      (click)="closeQuoteModal()"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M17.5 16.1667C17.6667 16.3333 17.75 16.5833 17.75 16.8333C17.75 17.0833 17.6667 17.3333 17.5 17.5C17.4167 17.5833 17.3333 17.6667 17.25 17.6667C17.1667 17.75 17 17.75 16.9167 17.75C16.8333 17.75 16.6667 17.75 16.5833 17.6667C16.5 17.5833 16.4167 17.5833 16.3333 17.5L10 11.3333L3.83333 17.5C3.75 17.5833 3.66667 17.6667 3.58333 17.6667C3.33333 17.75 3.08333 17.75 2.83333 17.6667C2.75 17.6667 2.58333 17.5833 2.5 17.5C2.33333 17.3333 2.25 17.0833 2.25 16.8333C2.25 16.5833 2.33333 16.3333 2.5 16.1667L8.66667 10L2.5 3.83333C2.16667 3.5 2.16667 2.91667 2.5 2.5C2.83333 2.16667 3.41667 2.16667 3.83333 2.5L10 8.66667L16.1667 2.5C16.5 2.16667 17.0833 2.16667 17.5 2.5C17.8333 2.83333 17.8333 3.41667 17.5 3.83333L11.3333 10L17.5 16.1667Z"
          fill="#20202A"
        />
      </svg>
    </button>

    <!-- Logo -->
    <div class="flex justify-center mb-8">
      <img
        src="assets/icons/new-logo-cantera.svg"
        alt="Cantera UNACEM"
        class="h-20"
      />
    </div>

    <!-- Título -->
    <h2
      class="text-[20px] font-poppins font-semibold text-neutral-gray-900 text-center mb-4"
    >
      Regístrate para continuar
    </h2>

    <!-- Descripción -->
    <p
      class="text-[14px] font-normal text-neutral-gray-700 font-poppins text-center mb-8"
    >
      Accede a todas las herramientas registrándote gratis o iniciando sesión
    </p>

    <!-- Botones -->
    <div class="flex flex-col gap-4">
      <button
        type="button"
        class="text-[16px] w-full h-14 rounded-xl font-poppins font-bold text-white transition-colors hover:opacity-95 bg-cantera-red-primary"
        (click)="goToRegister()"
      >
        Registrarme gratis
      </button>

      <button
        type="button"
        class="text-[16px] w-full h-14 rounded-xl font-poppins font-bold text-neutral-gray-900 transition-colors hover:bg-neutral-gray-100 border-2 border-neutral-gray-900"
        (click)="goToLogin()"
      >
        Iniciar sesión
      </button>
    </div>
  </div>
</div>
